<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          회원등록
        </div>
        <div>
          <member-write-component :memberType="`create`"></member-write-component>
          <div class="btn_box mt50" style="text-align: center">
            <el-button class="reg_btn_out" @click="save()">저장</el-button>
            <el-button class="com_btn" @click="$router.back()">취소</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberWriteComponent from "@/components/member/MemberWriteComponent";
import EventBus from "@/utils/event-bus";

export default {
  name: "MemberCreate",
  mixins: [],
  components: {
    MemberWriteComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    save() {
      EventBus.$emit('createMember');
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>